export default "__VITE_ASSET__Cjihn5IX__"